import React from 'react'
import { useTranslation } from 'react-i18next'
import Typography from 'components/molecules/typography'

const DealerNoCSPMessage = () => {
  const { t } = useTranslation()

  return (
    <>
      <Typography type="Level2Heading">{t('dealerNoCSP')}</Typography>
      <Typography type="ExplanationParagraph">
        {t('dealerNoCSPBody')}
      </Typography>
    </>
  )
}

export default DealerNoCSPMessage
